import { render, staticRenderFns } from "./RouterGoDeviceDetailsBtn.vue?vue&type=template&id=113400f6"
import script from "./RouterGoDeviceDetailsBtn.vue?vue&type=script&lang=ts"
export * from "./RouterGoDeviceDetailsBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports